<script>
  import { capitalize } from "./helpers.js";
  import SubjectCard from "./SubjectCard.svelte";
  import { extractLevelsText } from "./helpers";

  export let level = "";
  export let title = "";
  export let allLevels = "";
  export let subjects;
  let headingText;
  if (allLevels) {
    const levelWord = allLevels.length === 1 ? "Level" : "Levels";
    const levelText = extractLevelsText(allLevels);
    headingText = `${levelWord} ${levelText} Most Missed`;
  } else {
    headingText = `Level ${level} ${capitalize(title)}`;
  }
</script>

<style>
  h2 {
    font-family: var(--font-family-heading);
    font-size: 1.5rem;
    margin-top: 0;
  }
  ul {
    display: grid;
    grid-gap: 2rem;
    grid: 1fr / repeat(auto-fit, minmax(250px, 295px));
    margin: 0 0 5rem;
    padding: 0;
  }

  @media screen and (max-width: 1024px) {
    ul {
      grid: 1fr / repeat(auto-fit, minmax(295px, 1fr));
    }
  }
</style>

<div data-subject-grouping={title}>
  {#if title || allLevels}
    <h2>{headingText}</h2>
  {/if}
  <ul data-testid={`${title}-results-area`}>
    {#each subjects as subject}
      <SubjectCard {subject} />
    {/each}
  </ul>
</div>
